module.exports = __webpack_public_path__ + "img/番外_开国大典_02_登基.e4f0c8c6.png";